import {
    FiEdit2,
    FiTrash2,
    FiEye,
    FiCheck,
    FiX,
} from "react-icons/fi";


export default function CrudActions({

    // ---------------------------------------------------------
    // CRUD ACTIONS
    // ---------------------------------------------------------

    onView,
    onEdit,
    onDelete,

    showView = false,
    showEdit = true,
    showDelete = true,

    viewTitle = "View",
    editTitle = "Edit",
    deleteTitle = "Delete",


    // ---------------------------------------------------------
    // WORKFLOW ACTIONS
    // ---------------------------------------------------------

    onApprove,
    onReject,

    showApprove = false,
    showReject = false,

    approveTitle = "Approve",
    rejectTitle = "Reject",


    // ---------------------------------------------------------
    // GENERAL
    // ---------------------------------------------------------

    disabled = false,

}) {

    return (

        <div
            className="
                flex
                items-center
                gap-2
                whitespace-nowrap
            "
        >

            {/* =================================================
                VIEW
            ================================================= */}

            {showView && onView && (

                <button
                    type="button"
                    title={viewTitle}
                    aria-label={viewTitle}
                    disabled={disabled}
                    onClick={onView}
                    className="
                        inline-flex
                        h-9
                        w-9
                        items-center
                        justify-center
                        rounded-lg
                        border
                        border-blue-200
                        bg-blue-50
                        text-blue-600
                        transition-all
                        duration-150
                        hover:border-blue-300
                        hover:bg-blue-100
                        hover:text-blue-700
                        focus:outline-none
                        focus:ring-2
                        focus:ring-blue-200
                        disabled:cursor-not-allowed
                        disabled:opacity-50
                    "
                >
                    <FiEye
                        size={16}
                        strokeWidth={2}
                    />
                </button>

            )}


            {/* =================================================
                EDIT
            ================================================= */}

            {showEdit && onEdit && (

                <button
                    type="button"
                    title={editTitle}
                    aria-label={editTitle}
                    disabled={disabled}
                    onClick={onEdit}
                    className="
                        inline-flex
                        h-9
                        w-9
                        items-center
                        justify-center
                        rounded-lg
                        border
                        border-amber-200
                        bg-amber-50
                        text-amber-600
                        transition-all
                        duration-150
                        hover:border-amber-300
                        hover:bg-amber-100
                        hover:text-amber-700
                        focus:outline-none
                        focus:ring-2
                        focus:ring-amber-200
                        disabled:cursor-not-allowed
                        disabled:opacity-50
                    "
                >
                    <FiEdit2
                        size={16}
                        strokeWidth={2}
                    />
                </button>

            )}


            {/* =================================================
                APPROVE
            ================================================= */}

            {showApprove && onApprove && (

                <button
                    type="button"
                    title={approveTitle}
                    aria-label={approveTitle}
                    disabled={disabled}
                    onClick={onApprove}
                    className="
                        inline-flex
                        h-9
                        w-9
                        items-center
                        justify-center
                        rounded-lg
                        border
                        border-green-200
                        bg-green-50
                        text-green-600
                        transition-all
                        duration-150
                        hover:border-green-300
                        hover:bg-green-100
                        hover:text-green-700
                        focus:outline-none
                        focus:ring-2
                        focus:ring-green-200
                        disabled:cursor-not-allowed
                        disabled:opacity-50
                    "
                >
                    <FiCheck
                        size={16}
                        strokeWidth={2}
                    />
                </button>

            )}


            {/* =================================================
                REJECT
            ================================================= */}

            {showReject && onReject && (

                <button
                    type="button"
                    title={rejectTitle}
                    aria-label={rejectTitle}
                    disabled={disabled}
                    onClick={onReject}
                    className="
                        inline-flex
                        h-9
                        w-9
                        items-center
                        justify-center
                        rounded-lg
                        border
                        border-orange-200
                        bg-orange-50
                        text-orange-600
                        transition-all
                        duration-150
                        hover:border-orange-300
                        hover:bg-orange-100
                        hover:text-orange-700
                        focus:outline-none
                        focus:ring-2
                        focus:ring-orange-200
                        disabled:cursor-not-allowed
                        disabled:opacity-50
                    "
                >
                    <FiX
                        size={16}
                        strokeWidth={2}
                    />
                </button>

            )}


            {/* =================================================
                DELETE
            ================================================= */}

            {showDelete && onDelete && (

                <button
                    type="button"
                    title={deleteTitle}
                    aria-label={deleteTitle}
                    disabled={disabled}
                    onClick={onDelete}
                    className="
                        inline-flex
                        h-9
                        w-9
                        items-center
                        justify-center
                        rounded-lg
                        border
                        border-red-200
                        bg-red-50
                        text-red-600
                        transition-all
                        duration-150
                        hover:border-red-300
                        hover:bg-red-100
                        hover:text-red-700
                        focus:outline-none
                        focus:ring-2
                        focus:ring-red-200
                        disabled:cursor-not-allowed
                        disabled:opacity-50
                    "
                >
                    <FiTrash2
                        size={16}
                        strokeWidth={2}
                    />
                </button>

            )}

        </div>

    );

}